import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import HierarchyModal from '../Utils/HierarchyModal';
import { getList, submit } from '../Utils/FormCalls';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";
import { MAXIMOASSET, MAXIMO } from '../../../../commons/api';
import { Form, Select, Button, Tabs, message, Modal } from 'antd';
import { EditOutlined, UpSquareOutlined } from '@ant-design/icons';
import themeSettings from '../../../../commons/styles/themeSettings.json';
//import { registerPostUpdate } from 'echarts';

const { Option } = Select;

const ApiList = {
  getDeviceHierarchyList: `${MAXIMOASSET.DeviceHierarchy}`,
  getParameterByDevice: `${MAXIMOASSET.ParameterByDevice}`,
  getInterval: `${MAXIMOASSET.IntervalList}`,
  getUpdateIntervals: `${MAXIMOASSET.UpdateIntervals}`,
  getList: `${MAXIMO.List}`,
  getEditDetails: `${MAXIMOASSET.Edit}`
};
const IntervalMasterDetails = (props) => {
 
   const [formObject,setFormObject] = useState({});
  // const [deviceTypeList,setDeviceTypeList] = useState([]);
   const [deviceList,setDeviceList] = useState([]);
   const [treeVisible,setTreeVisible] = useState(false);
   const [selectedDevice,setSelectedDevice] = useState([]);
  // const [selectedDeviceObject,setSelectedDeviceObject] = useState([]);
   const [checkedValue,setCheckedValue] = useState([]);
   const [,setUserProfile] = useState(props && props.userProfile ? props.userProfile : {});
  // const [expandedKey,setExpandedKey] = useState(null);
  // const [expanded,setExpanded] = useState(false);
  // const [record,setRecord] = useState(props.location && props.location.state ? props.location.state.record : {});
  // const [dataSource,setDataSource] = useState([]);
   const [presentActiveKey,setPresentActiveKey] = useState('Master List');
   const [IntervalList,setIntervalList] = useState(null);
   const [Edit,setEdit] = useState(false);
   const [list,setList] = useState(null);
   const [,setTranslationCache] = useState(null);
   const [parameterList,setParameterList] = useState(null);
   const [selectedInterval,setSelectedInterval] = useState(null);
   const [selectedParameter,setSelectedParameter] = useState(null);
   const [,setDevice] = useState(null);
   const [,setParameterCode] = useState();
   
   const hRef = useRef(null);
  
useEffect(async () => {
  let path = props.location.pathname.split('/rubus/Maximo/');
  let Module = path[1].split('/') && path[1].split('/')[0];
  let deviceList = await getList(ApiList.getDeviceHierarchyList, Module);
  let IntervalList = await getList(ApiList.getInterval, Module);
  let list = await getList(ApiList.getList, Module);

  setDeviceList(deviceList);
  setIntervalList(IntervalList);
  setList(list);

},[]);
 
  useEffect(() => {
     setUserProfile(props.userProfile);
     setTranslationCache(props.translationCache);
  
  },[props.userProfile,props.translationCache]);

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFormsubmit = async () => {
    // let { selectedInterval, selectedParameter, selectedDevice } = this.state;
    let path = props.location.pathname.split('/rubus/Maximo/');
    let Module = path[1].split('/') && path[1].split('/')[0];
    if (selectedParameter !== null) {
      let payload = {
        Device: selectedDevice,
        Parameter: selectedParameter,
        Interval: selectedInterval
      };
      let response = await submit(ApiList.getUpdateIntervals, payload);
      let list = await getList(ApiList.getList, Module);
      message.success(response.message);
      setPresentActiveKey(list);
    } else {
      alert('please select parameter');
    }
  };
  const onModalsOk = async (e) => {
    e.preventDefault();
    let parameterList = await getParameterListByDevice(checkedValue);
  
    setParameterList(parameterList);
    setSelectedDevice(checkedValue);
    setTreeVisible(false);
    
  };

  const OnIntervalTypeChange = (value) => {
    setSelectedInterval(value);
  };

  const OnParameterTypeChange = (value) => {
    setSelectedParameter(value);
  };

 const handleEdit = async (record) => {
    let editData = [];
    editData = await editList(record.Id);
    // let val=(editData && editData[0] &&editData[0]['DeviceAlias']);
    let parameterList = {};
    // if (editData && editData[0] && editData[0]['DeviceAlias']) {
    //   parameterList = await this.getParameterListByDevice([val]);
    // }
    hRef.current &&
       hRef.current.setFieldsValue({
        ParameterCode: editData && editData[0]['ParameterAlias'],
        Interval: editData && editData[0] && editData[0]['CronTimeInterval']
      });
    let data = {
      selectedDevice: editData && editData[0] && editData[0]['DeviceAlias'],
      ParameterCode: editData && editData[0]['ParameterAlias'],
      Interval: editData && editData[0] && editData[0]['CronTimeInterval']
    };

    this.setState({
      selectedParameter: editData && editData[0] && editData[0]['ParameterAlias'],
      selectedDevice: editData && editData[0] && editData[0]['DeviceAlias'],
      checkedValue: editData && editData[0] && editData[0]['DeviceAlias'],
      formObject: data,
      presentActiveKey: 'Master Details',
      parameterList,
      Edit: 'true'
    });
    setSelectedParameter(editData && editData[0] && editData[0]['ParameterAlias']);
    setSelectedDevice(editData && editData[0] && editData[0]['DeviceAlias']);
    setCheckedValue(editData && editData[0] && editData[0]['DeviceAlias']);
    setFormObject(data);
    setPresentActiveKey('Master Details');
    setParameterList(parameterList);
    setEdit('true');
  };
  const onModalCancel = () => {
    setTreeVisible(false);
    setPresentActiveKey('Master Details');
  };
  const getParameterListByDevice = async(AliasCode) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const ParameterTypeObject = {
      method: 'POST',
      url: `${ApiList.getParameterByDevice}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        AliasCode: AliasCode
      }
    };
    return axios(ParameterTypeObject)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };
  const editList = async(Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const ParameterTypeObject = {
      method: 'GET',
      url: `${ApiList.getEditDetails}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(ParameterTypeObject)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

 const hierarchyDropdownChange = (value) => {
    setCheckedValue(value);
  };

  
    const columns = [
      {
        title: translation('Asset Device hierarchy'),
        dataIndex: 'Device',
        key: 'Device'
      },
      {
        title: translation('Parameter'),
        dataIndex: 'ParameterCode',
        key: 'ParameterCode'
      },
      {
        title: translation('Interval'),
        dataIndex: 'Interval',
        key: 'Interval'
      },
      {
        title: 'Actions',
        dataIndex: 'Actions',
        key: 'Actions',
        render: (_text, record) => (
          <Button

            onClick={() => handleEdit(record)}
            // onClick={() => this.editUsecase(record.Id)}
            
          >
            <EditOutlined />
          </Button>
        )
      }
    ];
    let items = [
      {
        key: 'Master List',
        label: translation('Master List'),
        children: (
          <StyledTable size="small"
            //pagination={pagination}
            //onChange={handleTableChange}
            style={{
              paddingTop: '20px'
            }}
            columns={columns}
            dataSource={list}
          />
        ),
      },
      {
        key: 'Master Details',
        label: translation('Master Details'),
        children: (
          <Form
            name="Equipment Master"
            theme={themeSettings}
            ref={hRef}
            onFinish={onFormsubmit}
            initialValues={formObject || {}}
            layout="horizontal"
            labelCol={{ flex: '200px' }}
            labelAlign="right"
            labelWrap
          >
            <div style={{ display: 'flex', justifyContent: 'right', paddingTop: '20px' }}>
              <Form.Item>
                <Button theme={themeSettings} type="primary" htmlType="submit">
                  {Edit && Edit === 'true' ? 'Update' : 'Submit'}
                </Button>
              </Form.Item>
            </div>
            <Form.Item
              name={'selectedDevice'}
              label={'Asset Device hierarchy'}
              style={{
                width: '100%',
                flex: '100%'
              }}
            >
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start'
                }}
              >
                <Select
                  style={{
                    width: '75%',
                    opacity: 1,
                    pointerEvents: 'none'
                  }}
                  value={selectedDevice}
                  mode="multiple"
                  placeholder={'Select Asset Device hierachy'}
                  
                >
                  {deviceList &&
                    Array.isArray(Object.keys(deviceList)) &&
                    Object.keys(deviceList).map((device, index) => {
                      return (
                        <Option key={index} value={deviceList[device]}>
                          {deviceList[device].Name}
                        </Option>
                      );
                    })}
                </Select>
                <Button
                  style={{ width: '5%' }}
                  type="primary"
                  onClick={() => {
                    setTreeVisible(true);
                  }}
                  disabled={Edit && Edit === 'true' ? true : false}
                >
                  <UpSquareOutlined />
                </Button>
              </span>
            </Form.Item>
            <Form.Item
              label="Select Parameter"
              name="ParameterCode"
              rules={[{ required: false }]}
              style={{
                width: '100%',
                flex: '100%',
                paddingTop: '10px'
              }}
            >
              <Select
                placeholder="Please Select Parameter"
                style={{ width: '80%' }}
                onChange={OnParameterTypeChange}
                mode={'multiple'}
                disabled={Edit && Edit === 'true' ? true : false}
              >
                {parameterList &&
                  Array.isArray(parameterList) &&
                  parameterList.map((item, index) => {
                    return (
                      <Option key={index} value={item.ParameterAlias}>
                        {item.ParameterAlias}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              label="Interval"
              name="Interval"
              rules={[{ required: true, message: 'Please Select Interval!' }]}
              style={{
                width: '100%',
                flex: '100%',
                paddingTop: '10px'
              }}
            >
              <Select
                placeholder="Please Select Interval "
                style={{ width: '80%' }}
                onChange={OnIntervalTypeChange}
              >
                {IntervalList &&
                  Array.isArray(IntervalList) &&
                  IntervalList.map((item, index) => {
                    return (
                      <Option key={index} value={item.Id}>
                        {item.TimeInterval}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Modal
              open={treeVisible}
              width={800}
              closable
              title={'Select Asset Device hierachy'}
              okText={'Add'}
              onOk={onModalsOk}
              onCancel={onModalCancel}
            >
              <HierarchyModal
                Edit={Edit}
                checkedArray={checkedValue ? checkedValue : []}
                treeData={deviceList}
                Key="Interval"
                handleDropdownChange={hierarchyDropdownChange}
              />
            </Modal>
          </Form>),
      }
    ];
    return (
      <div style={{ padding: '20px', minHeight: '300px', height: '1500px' }}>
        <Tabs
          defaultActiveKey="Master List"
          type="card"
          activeKey={presentActiveKey}
          onChange={(activeKey) => {
            if (activeKey === 'Master List') {
              setPresentActiveKey(activeKey);
            } else {
              setPresentActiveKey('Master Details');
              setEdit('false');
              setSelectedDevice([]);
              setCheckedValue([]);
              setDevice([]);
              setParameterCode([]);
              setFormObject({});

              hRef.current &&
                hRef.current.setFieldsValue({
                  selectedDevice: [],
                  checkedValue: [],
                  Device: [],
                  ParameterCode: [],
                  Interval: '',
                  formObject: {}
                });
            }
          }}
          items={items}
        />
      </div>
    );
  };


const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.getUserProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(IntervalMasterDetails);
